import { SIGN_OUT } from 'Global/Stores/auth'

const OPTIONS_ADVISOR_GET = 'API|OPTIONS/ADVISOR/GET'
const OPTIONS_ADVISOR_GET_FULFILLED = `FULFILLED_${OPTIONS_ADVISOR_GET}`
const OPTIONS_ADVISOR_GET_REJECTED = `REJECTED_${OPTIONS_ADVISOR_GET}`

const OPTIONS_RESERVATION_EVENT_ADD = 'OPTIONS/RESERVATION/EVENT/ADD'

const OPTIONS_RESERVATION_EVENT_GET = 'API|OPTIONS/RESERVATION/EVENT/GET'
const OPTIONS_RESERVATION_EVENT_GET_FULFILLED = `FULFILLED_${OPTIONS_RESERVATION_EVENT_GET}`
const OPTIONS_RESERVATION_EVENT_GET_REJECTED = `REJECTED_${OPTIONS_RESERVATION_EVENT_GET}`

const OPTIONS_RESERVATION_USER_GET = 'API|OPTIONS/RESERVATION/USER/GET'
const OPTIONS_RESERVATION_USER_GET_FULFILLED = `FULFILLED_${OPTIONS_RESERVATION_USER_GET}`
const OPTIONS_RESERVATION_USER_GET_REJECTED = `REJECTED_${OPTIONS_RESERVATION_USER_GET}`

/**
 * Action to add a reservation event option.
 * @param {object} eventOption - Event option object.
 * @returns {object} Action object.
 */
export const reservationEventOptionAdd = eventOption => ({
  payload: eventOption,
  type: OPTIONS_RESERVATION_EVENT_ADD,
})

/**
 * GET request to the API to get advisor options.
 * @returns {object} Action object.
 */
export const getAdvisorOptions = () => ({
  meta: { url: '/api/v1/users/getAdvisors' },
  type: OPTIONS_ADVISOR_GET,
})

/**
 * GET request to the API to get reservation event options.
 * @returns {object} Action object.
 */
export const getReservationEventOptions = () => ({
  meta: { url: '/api/v1/events/eventOptions' },
  type: OPTIONS_RESERVATION_EVENT_GET,
})

/**
 * GET request to the API to get reservation user options.
 * @returns {object} Action object.
 */
export const getReservationUserOptions = () => ({
  meta: { url: '/api/v1/users/reservationUserOptions' },
  type: OPTIONS_RESERVATION_USER_GET,
})

const initialState = {
  advisor: [],
  advisorDone: false,
  reservationEvent: [],
  reservationEventDone: false,
  reservationUser: [],
  reservationUserDone: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case OPTIONS_ADVISOR_GET_FULFILLED:
      return {
        ...state,
        advisor: payload.data,
        advisorDone: true,
      }

    case OPTIONS_ADVISOR_GET_REJECTED:
      return {
        ...state,
        advisorDone: true,
      }

    case OPTIONS_RESERVATION_EVENT_ADD:
      return {
        ...state,
        reservationEvent: [...state.reservationEvent, payload],
      }

    case OPTIONS_RESERVATION_EVENT_GET_FULFILLED:
      return {
        ...state,
        reservationEvent: payload.data,
        reservationEventDone: true,
      }

    case OPTIONS_RESERVATION_EVENT_GET_REJECTED:
      return {
        ...state,
        reservationEventDone: true,
      }

    case OPTIONS_RESERVATION_USER_GET_FULFILLED:
      return {
        ...state,
        reservationUser: payload.data,
        reservationUserDone: true,
      }

    case OPTIONS_RESERVATION_USER_GET_REJECTED:
      return {
        ...state,
        reservationUserDone: true,
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
